"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useOverflowItem", {
    enumerable: true,
    get: ()=>useOverflowItem
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const _overflowContext = require("./overflowContext");
function useOverflowItem(id, priority, groupId) {
    const ref = _react.useRef(null);
    const registerItem = (0, _overflowContext.useOverflowContext)((v)=>v.registerItem);
    (0, _reactUtilities.useIsomorphicLayoutEffect)(()=>{
        if (ref.current) {
            return registerItem({
                element: ref.current,
                id,
                priority: priority !== null && priority !== void 0 ? priority : 0,
                groupId
            });
        }
    }, [
        id,
        priority,
        registerItem,
        groupId
    ]);
    return ref;
} //# sourceMappingURL=useOverflowItem.js.map

//# sourceMappingURL=useOverflowItem.js.map